import { Container } from './styles';

export function Footer() {
    return (
        <Container>
            <div className="logoFooter">
                <img src="https://mkt.unipam.edu.br/imagens/marca/monocromatico/unipam/com-slogan/logo_unipam_horizontal_com_slogan_branco_272x72.png" alt="Logomarca Unipam" />
            </div>
            <div className="copyright">
            UNIPAM - Copyright © 2022
            </div>
        </Container>
    )
}